import React from 'react';

const AdvancedBlock = ({ data }) => {
  return (
    <section className="advanced">
      <div 
        dangerouslySetInnerHTML={{ __html: data.html }}
      />
    </section>
  );
};

export default AdvancedBlock; 